import { useOwnProfileQuery, useReportQuery } from '@common/cache';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useReportStore } from '@store';

export const useReportPage = () => {
  const {
    setReport,
    introspection,
    setIsModalOpen,
    setFilters,
    report,
    isFormInitialized,
    setIsFormInitialized,
    setHideSaveOptions,
    hideSaveOptions,
    setIsOwner,
  } = useReportStore();
  const { report_id } = useParams();

  const query = useReportQuery({ report_id });
  const { data: userProfile } = useOwnProfileQuery();

  useEffect(() => {
    if (query.data?.id && query.data?.id === report?.id) {
      setReport({ ...report, private: query.data.private });
    }
  }, [query.data?.private]);

  useEffect(() => {
    if (!query.data?.id) return;

    const fetchedReport = query.data;
    setReport({
      ...fetchedReport,
      organization_id: fetchedReport?.report_folder?.organization?.id,
    });
    setFilters(
      fetchedReport.options.$and?.map(o => ({
        field: o.field,
        value: o.value,
        operator: o.operator,
        label:
          introspection?.filters?.find(f => f.field === o.field)?.label ??
          o.field,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      })) as any,
    );
    setIsFormInitialized(true);
  }, [query.data?.id]);

  useEffect(() => {
    if (!isFormInitialized && !report_id) {
      setIsModalOpen(true);
    }
  }, [isFormInitialized]);

  useEffect(() => {
    if (userProfile?.id && query?.data && report_id) {
      setHideSaveOptions(
        userProfile?.id !== query?.data?.created_by?.id &&
          !query.data.allow_others_to_edit,
      );
      setIsOwner(userProfile?.id === query?.data?.created_by?.id);
    }
  }, [userProfile, query.data?.id]);

  return {
    isFormInitialized,
    hideSaveOptions,
  };
};
